/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/12/2024
 */

import { Box, Button, Container, Paper, Toolbar, Typography } from "@mui/material"
import { useState } from "react";
import { useDispatch } from "react-redux"
import SearchBar from "../Components/Shared/SearchBar";
import NotificationTable from "../Components/Notification/NotificationTable";
import { useGetAllNotificationsQuery } from "../Store/Services/NotificationService";
import NotificationDialog from "../Components/Notification/NotificationDialog";

import styles from "./Management.module.css"
import { openNotificationForm } from "../Store/Slices/notificationSlice";

const NotificationManagement = () => {
    const dispatch = useDispatch();
    const [searchData, setSearchData] = useState([])
    const { data, isSuccess, isLoading } = useGetAllNotificationsQuery();


    const handleClose = () => {
        dispatch(openNotificationForm(false));
    }

    const roles = sessionStorage.getItem("roles")

    return (
        roles?.split(",").includes("PRIV_ES_DISPLAY_NOTIFICATIONS") ? (
        <Paper elevation={3} className={styles.pageContainer} style={{backgroundImage: `url(${process.env.REACT_APP_IMAGE_URL}E_SERVICE/thumbnail_Management.png)`}}>
            <Box>
                <Toolbar className={styles.subNavBar}>
                    <Typography className={styles.topic}>Notification Management</Typography>
                </Toolbar>
            </Box>
            <Container id={styles.container}>
                <SearchBar
                    data={isSuccess || isLoading ? data?.notifications : []}
                    setSearchData={setSearchData}
                    text="Search Notifications"
                    search="notification"
                />
            </Container>

            <Container>
               {isSuccess && <NotificationTable data={Array.isArray(searchData) && searchData.length > 0 ? searchData : data?.notifications}/>}
            </Container>

            <NotificationDialog handleClose={handleClose} />
        </Paper> ) : null
    )
}

export default NotificationManagement